/**
 * Smile.io Facade Pattern
 * Lädt Smile.io Loyalty Widget erst bei Interaktion
 * Performance-Gewinn: ~74ms Hauptthread-Blockierung
 */

(function () {
  'use strict';

  let smileLoaded = false;
  let smileLoading = false;

  /**
   * Lädt Smile.io Script
   */
  function loadSmileIO() {
    if (smileLoaded || smileLoading) return;
    smileLoading = true;

    // Lade Smile.io Script
    const script = document.createElement('script');
    script.src = 'https://js.smile.io/v1/smile-shopify.js';
    script.async = true;
    script.onload = function () {
      smileLoaded = true;
    };
    document.head.appendChild(script);
  }

  /**
   * Event Handler für Interaktion
   */
  function onInteraction() {
    loadSmileIO();
    cleanup();
  }

  /**
   * Entfernt Event Listener nach dem Laden
   */
  function cleanup() {
    window.removeEventListener('scroll', onInteraction, { passive: true });
    window.removeEventListener('touchstart', onInteraction, { passive: true });
    window.removeEventListener('mousemove', onInteraction, { passive: true });
    window.removeEventListener('click', onInteraction);
    window.removeEventListener('keydown', onInteraction);
  }

  /**
   * Initialisierung
   */
  function init() {
    // Prüfe ob Smile.io Initializer vorhanden ist
    const smileInit = document.querySelector('.smile-shopify-init');
    if (!smileInit) {
      return;
    }

    // Registriere Event Listener für jede Art von Interaktion
    window.addEventListener('scroll', onInteraction, { passive: true });
    window.addEventListener('touchstart', onInteraction, { passive: true });
    window.addEventListener('mousemove', onInteraction, { passive: true });
    window.addEventListener('click', onInteraction);
    window.addEventListener('keydown', onInteraction);

    // Fallback: Lade nach 3 Sekunden
    setTimeout(function () {
      if (!smileLoaded) {
        loadSmileIO();
        cleanup();
      }
    }, 3000);
  }

  // Starte nach DOM Ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

